import type { AsyncData } from '#app';
import type {
  IModelListQueryParamsRequest,
  IModelResponse,
} from '~/services/base/dto/base.dto';
import type { IModelUserResponse, ModelUserAsso } from './dto/user.dto';
import type { IModelDepartmentUsersResponse, IModelUserCountResponse } from './dto/user-department.dto';

export class UserRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService;
  }

  async getUser(
    params: IModelListQueryParamsRequest
  ): Promise<AsyncData<IModelResponse<IModelUserResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/user-asso/user-all`,
      this.configService,
      {
        params,
      }
    );
    return dataResult;
  }

  async getUserAssoById(
    id: string | number
  ): Promise<AsyncData<IModelResponse<ModelUserAsso>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/user-asso/user-all/${id}`,
      this.configService
    );
    return dataResult;
  }

  async createUser(
    params: any
  ): Promise<AsyncData<IModelResponse<ModelUserAsso>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/user-asso/user-all`,
      this.configService,
      {
        method: 'POST',
        body: {
          data: params,
        },
      }
    );
    return dataResult;
  }

  async updateUser(
    params: any
  ): Promise<AsyncData<IModelResponse<ModelUserAsso>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/user-asso/user-all`,
      this.configService,
      {
        method: 'PUT',
        body: {
          data: params,
        },
      }
    );
    return dataResult;
  }

  async changeStatusUser(
    params: any
  ): Promise<AsyncData<IModelResponse<ModelUserAsso>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/user`,
      this.configService,
      {
        method: 'PUT',
        body: {
          data: params,
        },
      }
    );
    return dataResult;
  }

  async uploadUserAvatar(
    formData: FormData
  ): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/user-asso/upload/avatar`,
      this.configService,
      {
        method: 'POST',
        body: formData,
      }
    );
    return dataResult;
  }

  async getUserAvatar(fileName: string): Promise<AsyncData<any, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/file/${fileName}`,
      this.configService,
      {
        // responseType: 'blob',
      }
    );
    return dataResult;
  }

  async revokeAPIKey(
    id: string | number
  ): Promise<AsyncData<IModelResponse<ModelUserAsso>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/user/api-key`,
      this.configService,
      {
        method: 'PUT',
        body: {
          data: {
            id,
          },
        },
      }
    );
    return dataResult;
  }

  async getUserDepartment(params: IModelListQueryParamsRequest): Promise<AsyncData<IModelResponse<IModelDepartmentUsersResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/department-mapping-association/department-mapping-user`,
      this.configService,
      {
        params,
      }
    );
    return dataResult;
  }

  async getUserCount(): Promise<AsyncData<IModelResponse<IModelUserCountResponse>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/user-asso/count-user`,
      this.configService
    );
    return dataResult;
  }
}
